import { TypeOf, object, string } from "zod";

const registerSchema = object({
    address: string().nonempty("Logradouro é obrigatório"),
    neighborhood: string().nonempty("Bairro é obrigatório"),
    state: string().nonempty("Estado é obrigatório"),
    city: string().nonempty("Cidade é obrigatório"),
    number: string().nonempty("Número é obrigatório"),
    additionalInfo: string().transform((additionalInfo) => additionalInfo === "" ? undefined : additionalInfo),
  })
  
  type RegisterInput = TypeOf<typeof registerSchema>;

  export type { RegisterInput };
  export { registerSchema };